module.exports = __webpack_public_path__ + "img/thaehan.39a4fb43.jpg";